<div class="pac-page">
  <div class="pac-page-head">
    <h1 class="pac-title">{{ 'academicCalendarLabel' | translate }}</h1>
  </div>

  <div class="pac-calendar-container">
    <div class="pac-loading-overlay" *ngIf="loadingData">
      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
    </div>
    <ngfc-calendar
      [fontSize]="15"
      [events]="events"
      [showSidebar]="false"
      [locale]="ngfcLocale"
      [editable]="false"
      [(date)]="ngfcDate"
      [view]="ngfcView"
      (navigate)="onNavigate($event)"
      (eventClick)="handleEventClick($event)"
    ></ngfc-calendar>
  </div>
</div>

<p-dialog [(visible)]="eventPopupVisible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [showHeader]="false" [style]="{ width: '420px' }" styleClass="pac-event-dialog" (onHide)="closeEventPopup()">
  <div class="pac-event-icon"><i class="ri-calendar-event-line"></i></div>
  <div class="pac-event-title">{{ selectedEvent?.title }}</div>
  <div class="pac-event-description">
    {{ selectedEvent?.description || ('descriptionNotAvailable' | translate) }}
  </div>
  <button type="button" class="pac-event-close-btn" (click)="closeEventPopup()">
    {{ 'close' | translate }}
  </button>
</p-dialog>
